/// <reference path="Helpers.js"/>
/// <reference path="ChartLab.js"/>

(function (sb) {
	var me = (sb.DataGroupLogic = {});

	var cache = {};
	var deletedGroups = {};
	var defaultDataGroup = null;
	var CurrentEditChartStyles = {};
	var loadedScatterOptions = true;

	/* variable to use for naming nameless groups, "Series 1" for instance */
	var dgCounter = 1;

	window.consts = {
		static_time: "0"
	};

	filteredList.enabled = true;

	function getDataGroupInfo(layoutElementItem) {
		return $.map(cache[layoutElementItem.guid], function (e) {
			return { dgGuid: e.dgGuid, groupName: e.groupName };
		});
	}

	function getMainDataGroupForLayoutElementItem(guid) {
		var dgs = cache[guid];
		for (var i = 0; i < dgs.length; i++)
			if (dgs[i].isMain)
				return dgs[i];

		return null;
	}

	function setDefaultProperties(dataGroup, elementItemGuid, elementType) {
		delete dataGroup.__type;

		if (!dataGroup.dgGuid)
			dataGroup.dgGuid = Helpers.generateGuid();

		dataGroup.guid = elementItemGuid;

		setDates(dataGroup);

		if (elementType == Storyboard.Constants.itemTypes.HEATMAP) {
			dataGroup.timeSelections.timeInterval = Storyboard.Constants.IntervalTypes.MONTH;
			dataGroup.textOptions.showAnswerTexts = false;
			dataGroup.textOptions.showQuestionTexts = false;
		}

		if (!dataGroup.groupName) {
			dataGroup.groupName = dataGroup.isMain ? 'Main series' : 'Sub series ' + dgCounter;
			dgCounter++;
		}
	}

	function setDates(dataGroup) {
		var startDate = dataGroup.timeSelections.startDate;
		var stopDate = dataGroup.timeSelections.stopDate;

		/* we have encountered json serialization */
		if (typeof startDate === 'string')
			startDate = Helpers.parseDate(dataGroup.timeSelections.strStartDate); // yy is 4 digit in datepicker
		if (typeof stopDate === 'string')
			stopDate = Helpers.parseDate(dataGroup.timeSelections.strStopDate);

		dataGroup.timeSelections.startDate = startDate;
		dataGroup.timeSelections.stopDate = stopDate;
	}

	function fixDatesForTimezone(dataGroup) {
		dataGroup.timeSelections.startDate = Helpers.formatDate(new Date(dataGroup.timeSelections.startDate));
		dataGroup.timeSelections.stopDate = Helpers.formatDate(new Date(dataGroup.timeSelections.stopDate));
	}
	function setFRCTData() {
		var vids = null;
		var frId = $("#formatRulesIds_ct").val();
		var rid = Helpers.getReportID();

		var dgid = null;
		var dgguid = null;

		var ct2 = true;

		API.setDataCT({ vids: vids, frId: frId, rid: rid, dgid: dgid, dgguid: dgguid, ct2: ct2 })
			.done(function (data) {
				$("#formattingRules_ct").css("display", "block");
				$('#ifrRules_ct').attr('src', '../TableTools/FormattingSetup.aspx');
			})
			.fail(function (data) { alert("ERROR") });
	}
	function setDataGroupsForLayoutElementItem(dataGroups, layoutElementItem) {
		for (var i = 0; i < dataGroups.length; i++)
			setDefaultProperties(dataGroups[i], layoutElementItem.guid);

		cache[layoutElementItem.guid] = dataGroups;
	}

	me.getDefaultDataGroup = function () {
		if (!defaultDataGroup)
			return null

		var clone = $.extend(true, {}, defaultDataGroup);
		clone.groupName = '';
		return clone;
	}

	me.getCopyOfMainDataGroup = function (guid) {
		var mainDg = getMainDataGroupForLayoutElementItem(guid)
		var copy = $.extend(true, {}, mainDg);
		copy.isMain = false;
		copy.groupName = '';
		return copy;
	}

	me.setDefaultDataGroup = function (dataGroup) {
		defaultDataGroup = defaultDataGroup || dataGroup;
	}

	function parseJsonDateInDatagroups(dataGroups) {
	    $(dataGroups).each(function() {
	        if (this.formattingRules.length > 0) {
	            for(var fr = 0;fr < this.formattingRules.length;fr++) {
	                var rule = this.formattingRules[fr];
	                rule.dateValue = new Date(parseInt(rule.dateValue.match(/\d+/)[0], 10));
	            }
	        }
	    });
	}

	me.SortDataGroupsBySortOrder = function (layoutElementItem) {
		var datagroups = cache[layoutElementItem.guid];
		datagroups.sort(function (a, b) {
			if (a.sortOrder < b.sortOrder)
				return -1;
			if (a.sortOrder > b.sortOrder)
				return 1;
			return 0;
		});

		cache[layoutElementItem.guid] = datagroups;
	}

	/* loads and caches datagroups for an element item. Returns info about groups, not their definition */
	//bulkRefresh is optional parametar. No need to pass anything as third parametar in this function except in BulkEditing call
    me.LoadDataGroupsForLayoutElementItem = function (layoutElementItem, layoutElement, bulkRefresh) {

        var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
		var message = elementType === Storyboard.Constants.itemTypes.SIMPLETABLE ? "Loading simple table settings" : "Loading chart settings";

		//clear settings for scatter
		$('#lbScatterX, #lbScatterY, #lbScatterZ').children().remove();
		$("#scatterSeriesOptions").children().remove();

		Helpers.perfJSonCall({
			method: 'GetDataGroupsForLayoutElementItem',
			data: {
				elementItem: layoutElementItem,
				area: (arguments.length > 2) ? 'chartlab' : 'chartsetup',
				part: Storyboard.ChartLab.openedChartLabArea ? Storyboard.ChartLab.openedChartLabArea.replace(/ /g, '_') : ""
			},
			fixCasing: true,
            message: locale.get(message) + '...',
			service: 'chartsetup',
			successCallback: function (dataGroups) {
				dgCounter = 1;
				cache[layoutElementItem.guid] = [];

				var area = dataGroups.item2;
				dataGroups = dataGroups.item1;

				/* no data groups defined for chart, create new one from template */
				if (dataGroups.length === 0) {
					DataGroupSelections.SetChartStyles(Storyboard.DataGroupLogic.GetChartStyleCacheWithGuid(layoutElement.guid));
					me.CreateDataGroupForLayoutElementItem(layoutElementItem);
					if (area == 'chartlab')
						Storyboard.ChartLab.chartSetupLoadedCallback();
					else
						Storyboard.GuiEvents.showEditPanel(layoutElementItem, layoutElement);
				}
				else {

				    parseJsonDateInDatagroups(dataGroups);
					dgCounter = dataGroups.length;

					setDataGroupsForLayoutElementItem(dataGroups, layoutElementItem);
					//if bulkRefresh is undefined then don't get styles from cache.
					if (typeof bulkRefresh === 'undefined' || bulkRefresh =='chartlab' ) {
						DataGroupSelections.SetChartStyles(Storyboard.DataGroupLogic.GetChartStyleCacheWithGuid(layoutElement.guid));
						Storyboard.DataGroupLogic.eventUpdateDataGroupList(getDataGroupInfo(layoutElementItem));
						if (area == 'chartlab') {
							Storyboard.ChartLab.chartSetupLoadedCallback(dataGroups[0].optionalChartSettings);
						} else
						    // #38649 - Wrong variables selected during load
						    $(document).bind('DAPI.QuestionsAndAnswersFetched', function () {
						        Storyboard.GuiEvents.showEditPanel(layoutElementItem, layoutElement, dataGroups[0].seriesSettings.seriesType);
						        $(document).unbind('DAPI.QuestionsAndAnswersFetched');

                                if (layoutElement.isImportedTemplate && $("#ddlCalculationType option[value='" + dataGroups[0].calculationType + "']").length < 1) {
                                    var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
                                    var elementTypeText = elementType == Storyboard.Constants.itemTypes.SIMPLETABLE ? "table" : "chart";

                                    var message = $('<p class="Message Message-error" style="display: none">' +
                                        'The project does not contain any variables that can be used with calculation type selected in the ' + elementTypeText + ' template.' +
                                        '</p > ');
                                    $("#wizardChart").prepend(message);
                                    $("#wizardChart").children('.Message').slideDown("fast");
                                    $("#wizardChart").children('.Message').delay(5 * 1000).slideUp("fast", function () {
                                        $(this).remove();
                                    });
                                }
						    });
					}
				}
			}
		});
	};
	
	/* creates a new data group by performing a web service call that just returns an empty data group */
	me.CreateDataGroupForLayoutElementItem = function (layoutElementItem) {
		/* if no data groups are defined, create new one from default template,
		otherwise use the first (main) data group as template */
		var dataGroup;
		if (cache[layoutElementItem.guid].length) {
			dataGroup = me.getCopyOfMainDataGroup(layoutElementItem.guid);
			dataGroup.sortOrder = cache[layoutElementItem.guid].length + 1;
		}
		else {
			dataGroup = me.getDefaultDataGroup();
			dataGroup.isMain = true;
			dataGroup.sortOrder = 1;
		}

        if (!dataGroup.isMain) {
            dataGroup.useMainOptionalFilterSettings = true;
            dataGroup.formattingRulesIds = [];
			dataGroup.overrideMainFormatRules = false;
        }

		dataGroup.dataGroupId = 0;
		cache[layoutElementItem.guid].push(dataGroup);
		dataGroup.chartOptions.tooltipItems = 8; // Axis label should be shown by defaut
		dataGroup.dgGuid = null;
		setDefaultProperties(dataGroup, layoutElementItem.guid, layoutElementItem.itemType);

		if (!dataGroup.isMain && (dataGroup.significanceOptions.positiveIconId > 0 || dataGroup.significanceOptions.negativeIconId > 0)) {
			Helpers.perfJSonCall({
				method: 'CopySigTestIcons',
				data: { positiveIconId: dataGroup.significanceOptions.positiveIconId, negativeIconId: dataGroup.significanceOptions.negativeIconId },
				successCallback: function (result) {
					dataGroup.significanceOptions.positiveIconId = result.item1;
					dataGroup.significanceOptions.negativeIconId = result.item2;

					Storyboard.DataGroupLogic.eventUpdateDataGroupList(getDataGroupInfo(layoutElementItem), dataGroup.dgGuid);
				},
				message: 'Copying settings...',
				fixCasing: true
			});
		} else
			Storyboard.DataGroupLogic.eventUpdateDataGroupList(getDataGroupInfo(layoutElementItem), dataGroup.dgGuid);
	};

	me.deleteDataGroupForLayoutElementItem = function (dataGroup, layoutElementItem) {
		/* adds the deleted datagroup to a special array,
		and removes it from the cache of datagroups */
		var deletions = deletedGroups[layoutElementItem.guid] || [];
		deletedGroups[layoutElementItem.guid] = deletions;
		deletions.push(dataGroup);


		for (var i = 0; i < cache[layoutElementItem.guid].length; i++)
			if (cache[layoutElementItem.guid][i].dgGuid == dataGroup.dgGuid)
				cache[layoutElementItem.guid].splice(i, 1);

		Storyboard.DataGroupLogic.eventUpdateDataGroupList(getDataGroupInfo(layoutElementItem));
	};

	function getAxisForLayoutElementItem(layoutElementItem, getSecondary) {
		var mainDG = getMainDataGroupForLayoutElementItem(layoutElementItem.guid);
		var axes = [].concat(mainDG.axisOptionsPool || mainDG.axisOptions);

		for (var i = 0; i < axes.length; i++)
			if (axes[i].isSecondary === getSecondary)
				return axes[i];

		return axes[0];
	}

	function setAxisForLayoutElementItem(layoutElementItem, axisOptions) {
		var mainDG = getMainDataGroupForLayoutElementItem(layoutElementItem.guid);
		var axes = [].concat(mainDG.axisOptionsPool || mainDG.axisOptions);

		var matchingAxis = null;
		for (var i = 0; i < axes.length && !matchingAxis; i++) {
			if (axes[i].isSecondary === axisOptions.isSecondary) {
				if (axes[i].isSecondary === axisOptions.isSecondary) {
					matchingAxis = axes[i] = axisOptions;

					//also update axisOptions for all datagroups that uses the same axis
					for (var dgi = 0, dg; (dg = cache[layoutElementItem.guid][dgi]); dgi++) {
						if (dg.axisOptions.isSecondary === axisOptions.isSecondary)
							dg.axisOptions = axisOptions;
					}

				}
			}
		}

		if (!matchingAxis) {
			axes.push(axisOptions);
			matchingAxis = axisOptions;
		}

		mainDG.axisOptionsPool = axes;
		return matchingAxis;
	}

	/* Stores the data group in cache for the provided element item */
	me.SetDataGroupWithGuid = function (layoutElementItem, dataGroup) {
		if (layoutElementItem.itemType != Storyboard.Constants.itemTypes.SIMPLETABLE)
			setAxisForLayoutElementItem(layoutElementItem, dataGroup.axisOptions);

		var dataGroups = cache[layoutElementItem.guid], i = 0;
		for (; i < dataGroups.length; i++) {
			if (dataGroups[i].dgGuid === dataGroup.dgGuid) {
				dataGroups[i] = dataGroup;
				delete dataGroups[i].index;
				return;
			}
		}
	};

	/* returns cached datagroup for element item, requires that LoadDataGroupsForLayoutElementItem has been called first */
	me.GetDataGroupWithGuid = function (layoutElementItem, dataGroupGuid) {
		var dataGroups = cache[layoutElementItem.guid];
		for (var i = 0; i < dataGroups.length; i++) {
			if (dataGroups[i].dgGuid === dataGroupGuid) {
				if (layoutElementItem.itemType != Storyboard.Constants.itemTypes.SIMPLETABLE)
					dataGroups[i].axisOptions = getAxisForLayoutElementItem(layoutElementItem, dataGroups[i].useSecondaryAxis);
				dataGroups[i].index = i;
				return dataGroups[i];
			}
		}
		return null;
	};

	me.GetDataGroupWithGuidAndMainGroup = function (layoutElementItem, dataGroupGuid) {
		var result = [];
		var dataGroup = this.GetDataGroupWithGuid(layoutElementItem, dataGroupGuid);
		if (!dataGroup.isMain)
			result.push(getMainDataGroupForLayoutElementItem(layoutElementItem.guid));

		result.push(dataGroup);
		return result;
	}

	me.SetChartStyleCacheWithGuid = function (styles, guid) {
		CurrentEditChartStyles[guid] = styles;
	}

	me.GetChartStyleCacheWithGuid = function (guid) {
		var cachedStyle = (typeof CurrentEditChartStyles[guid] != 'undefined') ? CurrentEditChartStyles[guid] : {};
		return cachedStyle;
	}

	me.getDataGroupsForLayoutElementItem = function (layoutElementItem) {
		return cache[layoutElementItem.guid];
	};

	me.getDeletedDataGroupsForLayoutElementItem = function (layoutElementItem) {
		return deletedGroups[layoutElementItem.guid] || [];
	};

	me.clearDataGroupsForGuid = function (layoutElementItem) {
		delete cache[layoutElementItem.guid];
	};

	me.eventUpdateDataGroupList = null;
	me.getMainDataGroupForLayoutElementItem = getMainDataGroupForLayoutElementItem;
	me.setDates = setDates;
	me.fixDatesForTimezone = fixDatesForTimezone;
	me.setFRCTData = setFRCTData;

	var API = (function () {
		var token = $('#ctl00_CP_hidToken').val();

		function POST(options) {
			var defaults = {
				method: 'POST',
				type: 'POST',
				contentType: 'application/json',
				headers: {
					'authorization': 'Bearer ' + token + ''
				}
			};

			var settings = $.extend(true, {}, defaults, options);

			return $.ajax(settings);
		}

		function setDataSimpleTable(data) {
			return POST({ url: '../TableTools/FormattingSetup.aspx/SetData', data: JSON.stringify(data) });
		}
		function setData(data) {
			return POST({ url: '../TableTools/FormattingSetup.aspx/SetData', data: JSON.stringify(data) });
		}
		function setDataCT(data) {
			return POST({ url: '../TableTools/FormattingSetup.aspx/SetData', data: JSON.stringify(data) });
		}

		return {
			setDataSimpleTable: setDataSimpleTable,
			setData: setData,
			setDataCT: setDataCT
		};

	})();


	/* Grouping data group gui logic */
	me.setupDataGroupEditing = function (contentElement, layoutElement) {
		IconShapeUI.getDefaultIcons(function () {
			/* store current selections as default/template to be used later when creating new charts */
			if (!Storyboard.DataGroupLogic.getDefaultDataGroup())
				Storyboard.DataGroupLogic.setDefaultDataGroup(ChartSetupUIObj.GetDatagroupFromGui());
		});

		// hide correlation and percentile options at first
		$(".hdCorrelationOption, #numericPercentileValue, #sbTextNumericPercentile, #sbTextNumericNote").hide();
		$("#correlationQuestionBox").parent().css("display", "none");

		/* clear all events, since they still hold references to previous edited chart */
		$("#btnCreateDataGroup, #ddlDataGroups, #btnUpdateChart, #tabSpecialSettings, #btnAddTargetArea, #btnAddGradientStop, #btnAddDynamicColorStop, #btnAddValueBasedColor").unbind("click").unbind("change");
		$("#txtQuestion").val('');
		$('#linkCloseFormattingRules').unbind('click').bind('click', function () {
			var ids = [];
			$("#ifrRules").contents().find('.hiddenRuleId').each(function () {
				ids.push($(this).val());
			});
			$('#formatRulesIds').val(ids.join(','));
			$('#formattingRules').css('display', 'none').appendTo($('#setupChart #settings'));
			$('#ifrRules').attr('src', '');
		});

		$("#btnCreateDataGroup").bind("click", function () {
			storeCurrentDataGroup();
			Storyboard.DataGroupLogic.CreateDataGroupForLayoutElementItem(contentElement);
			$(this).blur();
			checkScatterOptions();
		});

		$("#btnAddTargetArea").bind("click", function () {
			ChartSetupUI.addNewTargetArea();
		});
		$('#btnAddValueBasedColor').bind('click', function () {
			var $lastColorStop = $('#tblValueBasedColors tr[id^="valueBasedColor_"]').last();
			var index = 0;

			if ($lastColorStop.length)
				index = ChartSetupUI.addValueBasedColor($('#ValueBasedColorsTemplate'), $lastColorStop);
			else
				index = ChartSetupUI.addValueBasedColor($('#ValueBasedColorsTemplate'));

			$('#valueBasedColor_' + index).find('#ValueBasedColorsPreview_' + index)
				.DUIColorPicker({
					layout: 'template',
					transparent: false
				});
		});

		$("#btnAddDynamicColorStop").bind("click", function () {
			var $lastColorStop = $('#dynamicColorsTable tr[id^="dynamicColorStop_"]').last();
			var index = 0;

			if ($lastColorStop.length)
				index = ChartSetupUI.addSeriesColorStop($('#dynamicColorStopTemplate'), $lastColorStop);
			else
				index = ChartSetupUI.addSeriesColorStop($('#dynamicColorStopTemplate'));

			$('#dynamicColorStop_' + index).find('#dynamicColorPreview_' + index)
				.DUIColorPicker({
					layout: 'template',
					transparent: false
				});
		});

		$("#btnAddGradientStop").bind("click", function () {
			ChartSetupUI.addNewGradientStop();
		});

		$("#txtShowTopValuesPerGroup").bind("change textInput input", function () {
			var tableId = "tblShowTopValuePerGroupNames", rowTemplateClass = "serieNameTemplate";

			var rowsToAdd = $("#txtShowTopValuesPerGroup").val() - $("#" + tableId + " > tbody > .serieNameRow:not('." + rowTemplateClass + "')").length;
			if (rowsToAdd > 0) {
				var rowTemplate = $("." + rowTemplateClass);
				rowTemplate.show();
				while (rowsToAdd > 0) {
					var newRow = rowTemplate.clone();
					newRow.removeClass(rowTemplateClass);
					$("#" + tableId + " > tbody:last").append(newRow);
					newRow.find("label").text(newRow.index());
					rowsToAdd--;
				}
				rowTemplate.hide();
			} else {
				while (rowsToAdd < 0) {
					$("#" + tableId + " > tbody > .serieNameRow:not('." + rowTemplateClass + "')").last().remove();
					rowsToAdd++;
				}
			}
		});

		$("#chbShowTopValuesPerGroup").bind('change', function () {
			ChartSetupUI.enableValuesPerGroup();
			ChartSetupUI.disableRunTopAfterMeanAggregate();
		});

		$('#ddlColorSource').bind('change', function () {
			$('#scatterSeriesOptions').find('.scatterColor').toggle($(this).val() == '6');
			$('#tblScatterPointMeanQuadrantColors').toggle($(this).val() == '7');
			ChartSetupUI.showHideColorPickerForSeriesScatter();
		});

		$('#ddlBenchmarkAxis').bind('change', function () {
			ChartSetupUI.updateBenchmarkOptions();
		});

		$("#lbAxis").dblclick(function () { $('#btnMoveToLegend').click(); });
		$("#lbLegend").dblclick(function () { $('#btnMoveToAxis').click(); });
		
		$('#btnFormattingRules').unbind("click").bind('click', function () {
			var fRulesNo = $("#formatRulesIds").val().split(",").length;
			if (fRulesNo >= fRulesLimit)
				alert("You have " + fRulesNo + " Formatting rules. Please be aware that you only can have " + fRulesLimit + " rules defined.");

			Handlers.setDataSimpleTable();
		});

		$("#tabSpecialSettings").bind("click", function () {
			storeCurrentDataGroup();
			loadedScatterOptions = true;
			if (!validateDataGroups())
				return;
			var dataGroups = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);

			// TFS 19156: hide settings while loading is in progress
			$('#specialSettings fieldset > div.settingsFieldsetContent').hide();

			ChartSetupDataCom.LoadScatterOptions(dataGroups, function (data) {
				var scatterOptions = data.scatterOptions || {};
				var scatterSeries = data.scatterSeries;
				var seriesType = dataGroups[0].seriesSettings.seriesType;
				var isBubble = seriesType == Storyboard.Constants.SeriesTypes.BUBBLE;
				var minRadLabel = isBubble ? locale.get("Min.radius") : locale.get("Radius");
				$('#fieldSetZAxis, #scatterMaxRadius').toggle(isBubble);
				$('#scatterAxes').toggleClass('scatter-z-axes', isBubble);
				$('#lblMinScatterRadius').text(minRadLabel);

				var axes = ['#lbScatterX', '#lbScatterY', '#lbScatterZ'];
				var axesData = ['XAxisNode', 'YAxisNode', 'ZAxisNode'];
				var seriesLabels = [[]];

				for (let i = 0, m; (m = scatterSeries[i]); i++) {
					for (let a in axes)
						if (axes.hasOwnProperty(a)) {

							seriesLabels[a] = seriesLabels[a] || [];
							if (m[axesData[a]])
								seriesLabels[a].push({ Value: m[axesData[a]] || '', Text: m.Labels[a] || '' });
						}
				}

				for (let a in axes)
					if (axes.hasOwnProperty(a)) {
						if (seriesLabels[a]) {
							HTMLHelpers.bindSelect(axes[a], seriesLabels[a], 'Value', 'Text');
							$(axes[a]).DUIsmartSelectBox('destroy');
							$(axes[a]).DUIsmartSelectBox({
								'height': 'auto',
								'width': 'auto',
								'sorting': true,
								'textWrap': true
							});
							$(axes[a]).next()
							.addClass('scatterSmartSelectbox');
						}
					}

				var symbols = ['circle', 'diamond', 'square', 'triangle', 'triangle-down'];
				var symbolEntities = ['&#8226;', '&#9830;', '&#9632;', '&#9650;', '&#9660;'];

				//Set same symbol to all
				$('#scatterSymbolAllBtn').unbind('click');
				$('#lbScatterX')
					.unbind('movedUp')
					.unbind('movedDown');

				var symbolsHTMLAll = [];
				for (var i = 0; i < symbols.length; i++) {
					symbolsHTMLAll.push('<option value="' + symbols[i] + '">' + symbolEntities[i] + '</option>');
				}
				$('#scatterSymbolAll').html(symbolsHTMLAll.join(''));
				$('#scatterSymbolAllBtn').bind('click', function () {
					$('.scatterSymbol').children('select').val($('#scatterSymbolAll').val());
				});
				$('#lbScatterX')
					.bind('movedUp', function (evt) {
						$('#scatterSeriesOptions').children().each(function (ind) {
							for (var i = 0; i < evt.list.length; i++) {
								if (evt.list[i] == ind) $(this).insertBefore($(this).prev());
							}
						});
					})
					.bind('movedDown', function (evt) {
						var len = $('#scatterSeriesOptions').children().length;
						while (len >= 0) {
							var iterThis = $('#scatterSeriesOptions').children().eq(len);
							for (var i = 0; i < evt.list.length; i++) {
								if (evt.list[i] == len) iterThis.insertAfter(iterThis.next());
							}
							len--;
						}
					})

				//Remove exsting events
				$('#lbScatterXAsLabelBtn').unbind('click');
				$('#lbScatterYAsLabelBtn').unbind('click');
				$('#scatterLabelReplaceWin').unbind('click');


				$('#lbScatterXAsLabelBtn').bind('click', function () {
					$('#lbScatterX').children().each(function (ind) {
						$('#scatterSeriesOptions').children().eq(ind)
							.children('.scatterLabel').children('input').val($(this).text());
					});
				});
				$('#lbScatterYAsLabelBtn').bind('click', function () {
					$('#lbScatterY').children().each(function (ind) {
						$('#scatterSeriesOptions').children().eq(ind)
							.children('.scatterLabel').children('input').val($(this).text());
					});
				});
				$('#scatterLabelReplaceWin').attr('src', 'icons/edit-find-replace.png');
				$('#scatterLabelReplaceWin').bind('click', function () {
					var cHTML = [];
					
					cHTML.push('<table style="width: 100%; margin-bottom: 1em; border: 0">');
					cHTML.push(     '<tr>');
					cHTML.push(         '<td style="width: 30%; padding: 0 1em 0.5em 0; text-align: right;">');
					cHTML.push(             '<label style="font-weight: normal;">' + locale.get('Find string') + ':</label>');
					cHTML.push(         '</td>');
					cHTML.push(         '<td>');
					cHTML.push(             '<input id="scatterLabelReplaceWinFind" type="text" value="" autocomplete="off" style="width: 100%; margin: 0.5em 0;"/>');
					//cHTML.push(           '<input type="checkbox" id="scatterLabelReplaceWinFindRegExp"/> ' + locale.get('Use RegEx'));
					cHTML.push(         '</td>');
					cHTML.push(     '</tr>');
					cHTML.push(     '<tr>');
					cHTML.push(         '<td style="width: 30%; padding: 0 1em 0.5em 0; text-align: right;">');
					cHTML.push(             '<label style="font-weight: normal;">' + locale.get('Replace with string') + ':</label>');
					cHTML.push(         '</td>');
					cHTML.push(         '<td>');
					cHTML.push(             '<input id="scatterLabelReplaceWinReplace" type="text" value="" autocomplete="off" style="width: 100%; margin: 0.5em 0;"/>');
					//cHTML.push(           '<input type="checkbox" id="scatterLabelReplaceWinReplaceRegExp"/> ' + locale.get('Use RegEx'));
					cHTML.push(         '</td>');
					cHTML.push(     '</tr>');
					cHTML.push(     '<tr>');
					cHTML.push(         '<td style="width: 30%;">');
					cHTML.push(         '</td>');
					cHTML.push(         '<td>');
					cHTML.push(             '<small>(' + locale.get('Leave empty to remove string') + ')</small>');
					cHTML.push(         '</td>');
					cHTML.push(     '</tr>');
					cHTML.push('</table>');
					
					var replaceWin = new DUIwindow2({
						title: '<h2>' + locale.get('Find and Replace') + ' - ' + locale.get('Labels in Chart') + '</h2>',
						width: 500,
						html: cHTML.join(''),
						preWrapSpace: true,
						buttons: [{
							text: locale.get('Close'),
							onClick: function (evt) {
								//silent
								replaceWin.Close();
							}
						},
						{
							text: locale.get('Replace'),
							focused: true,
							onClick: function (evt) {
								var findEl = $('#scatterLabelReplaceWinFind');
								var findElVal = findEl.val();
								var findElIsRegExp = ($('#scatterLabelReplaceWinFindRegExp:checked').length > 0);
								var replaceEl = $('#scatterLabelReplaceWinReplace');
								var replaceElVal = replaceEl.val();
								var replaceElRegExp = ($('#scatterLabelReplaceWinReplaceRegExp:checked').length > 0);

								//support JS RegExp, like "[\d]*?"
								var findElValAdj = (findElIsRegExp) ? new RegExp(findElVal) : findElVal;
								var replaceElValAdj = (replaceElRegExp && !replaceElVal.length == 0) ? new RegExp(replaceElVal) : replaceElVal;

								$('#lbScatterY').children().each(function (ind) {
									var inp = $('#scatterSeriesOptions').children().eq(ind)
										.children('.scatterLabel').children('input');
									inp.val(inp.val().replace(findElValAdj, replaceElValAdj));
								});
							}
						}]
					});
					$('#scatterLabelReplaceWinFind').focus(); //focus first input field
				});


				//returns select element with 'symbol' as selected option
				var fnSymbolBind = function (symbol, rowIndex) {
					symbol = symbol || symbols[0];
					return ['<select>'].concat(
						$.map(symbols, function (v, i) {
							return '<option value="' + v + '" ' + (symbol == v ? 'selected' : '') + '>' + symbolEntities[i] + '</option>';
						})).concat('</select>').join('');
				};

				var scatterSettingsGrid = $("#scatterSeriesOptions");
				var rowData = [];
				for (let i = 0; i < scatterSeries.length; i++) {
					rowData.push('<div style="clear:both">');
					rowData.push('<div class="settingsFieldsetContent scatterOptions scatterShortText"><input type="text" autocomplete="off" value="' + (scatterSeries[i].ShortText || '') + '" class="fullInput"/></div>');
					rowData.push('<div class="settingsFieldsetContent scatterOptions scatterLabel"><input type="text" autocomplete="off" value="' + (scatterSeries[i].Label || scatterSeries[i].Labels[0]) + '" class="fullInput"/></div>');
					rowData.push('<div class="settingsFieldsetContent scatterOptions scatterSymbol">' + fnSymbolBind(scatterSeries[i].Symbol, i) + '</div>');
					rowData.push('<div class="settingsFieldsetContent scatterOptions scatterColor">');
					rowData.push('<input id="seriesColor' + i + '" class="ColorTextboxNoTransparent" type="text" autocomplete="off" value="' + Helpers.convertFromDecimalToHex(scatterSeries[i].Color) + '"  /></div>');
					rowData.push('</div>');
				}
				scatterSettingsGrid.children().remove();
				scatterSettingsGrid.append(rowData.join(''));

				$('#scatterAxes').show();

				for (let i = 0; i < scatterSeries.length; i++) {
					var color;
					if (scatterSeries[i].Color || scatterSeries[i].Color === 0) {
						color = Helpers.convertFromDecimalToHex(scatterSeries[i].Color);
					} else if ($.fn.DUIColorPicker.useNewColorTemplateLogic) {
						var standardPaletteCategory = $.fn.DUIColorPicker.find.standardPaletteCategory();
						var standardPaletteColor = standardPaletteCategory.colors[0];
						color = tinycolor(standardPaletteColor).toRgbString();
					} else
						color = '#000000';

					$('#seriesColor' + i).DUIcolorPicker({
						layout: 'template',
						transparent: false,
						selected: {
							colorString: color,
							templateColorId: scatterSeries[i].Color_colorPlaceholderId
						}
					});
				}

				$('input[name="scatterLabelPos"][value="' + (scatterOptions.LabelPosition || 1) + '"]').attr('checked', 'checked');
				$("#ddlColorSource").val(scatterOptions.ColorSource || 1);
				$("#ddlColorSource").trigger('change');
				$("#txtMinScatterRadius").val(scatterOptions.MinRadius || 8);
				$("#txtMaxScatterRadius").val(scatterOptions.MaxRadius || 20);
				$('#txtScatterPointOpacity').val(scatterOptions.PointOpacity || 50);
				$('#ddlScatterShortTextType').val(scatterOptions.ShortTextType || 4);
				ChartSetupUI.showHideShortTextTypeSettings();

				DataGroupSelections.SetScatterMeanSettings(data.scatterMeanOptions);

				// TFS 19156: show controls
				$('#specialSettings fieldset > div.settingsFieldsetContent').show();
			});
		});

		$("#btnUpdateChart").bind("click", function () {
			storeCurrentDataGroup();
			if (validateDataGroups()) {
				var dataGroups = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);
				var genSettings = GeneralSettings.getSelectedSettings();
                var styles = [];
                var columnToSortBy = "";
                var sortDirection = 0;
                if (contentElement.itemType == Storyboard.Constants.itemTypes.SIMPLETABLE) {
                    styles = RespondentTableSetup.getStyles();

                    var sortedColHeader = $('#divTable td.stSortableColumn[sortDirection]').length > 0 ? $('#divTable td.stSortableColumn[sortDirection]')[0] : null;
                    if (sortedColHeader) {
                        sortDirection = $(sortedColHeader).attr("sortDirection");
                        // if it's not a number then Update was clicked manually and sorting should be removed
                        if (isNaN(sortDirection))
                            sortDirection = 0;
                        else
                            columnToSortBy = $(sortedColHeader).attr("sortKey");
                    }
                }

                $('#divChart').empty();
                ChartSetupDataCom.GetPreviewChart(dataGroups, genSettings, contentElement, styles, columnToSortBy, sortDirection);
			}
		});

		$("#btnEditSeries, #btnSaveSeries").unbind("click").bind('click', function () {
			$('.editSelectedSeries').toggle();
		});

		$('#divChart, #divTable, .showDivTable, .invertBackground', '#chartPreview').hide();

		$("#chbShowDivTable").attr('checked', false).unbind("change").bind('change', function () {
			$('#divTable').slideToggle('fast');
		});

		$("#chbInvertChartPreview").attr('checked', false).unbind("change").bind('change', function () {
			$('#setupChart #preview').toggleClass('invert', this.checked);
		});

		$('#percentiles .percentileRow .colourPercentile:not(.colorpicker-target)').DUIColorPicker({layout: 'template'});
		$('#txtColorAbove:not(.colorpicker-target)').DUIColorPicker({layout: 'template'});
		$('#txtColorBelow:not(.colorpicker-target)').DUIColorPicker({layout: 'template'});

		if ($("#numericPercentileValue option").length !== 100) {
			var percents = [];
			for (var i = 1; i <= 100; i++) {
				percents.push({value: i, text: i + "%"});
			}
			HTMLHelpers.bindSelect("#numericPercentileValue", percents, "value", "text");
		}

		function editDatagroup(dgGuid, layoutElement, contentElement) {
			var elementType = Storyboard.LayoutDesigner.getLayoutElementType(layoutElement);
			var dataGroup = Storyboard.DataGroupLogic.GetDataGroupWithGuid(contentElement, dgGuid);
			var dgButton = $(".dgButton[dgGuid=" + dgGuid + "]");

			$("#txtSeriesName").val(dataGroup.groupName);
			$("#txtSeriesName").unbind("blur").bind("blur", function () {
				dgButton.val($("#txtSeriesName").val());
			});
			//reset sorting info
			$("#ddlAxisSort").val(dataGroup.sortingInfo.axisSort);
			$("#ddlLegendSort").val(dataGroup.sortingInfo.legendSort);

			$("#ddlSeriesSortOrder").val(dataGroup.sortOrder);
			$("#ddlSeriesSortOrder").unbind("change").bind("change", function () {
				var selectedGroup = Storyboard.DataGroupLogic.GetDataGroupWithGuid(contentElement, $("#dgGuid").val());
				var newSortOrder = parseInt($(this).val(), 10);
				if (selectedGroup && !selectedGroup.isMain) {
					$(".dataGroupsSelections > .dgButton:not(.selectedButton):eq(" + (newSortOrder - 2) + ")").after($(".dgButton.selectedButton"));
					updateSortOrder();
				}
				Storyboard.DataGroupLogic.SortDataGroupsBySortOrder(contentElement);
			});
			if (dataGroup.isMain) {
				$("#btnDeleteSeries").hide();
				$("#ddlSeriesSortOrder").closest("div").hide();
				if (elementType === Storyboard.Constants.itemTypes.CHART)
					$("#DUI-ST-MULTIEDIT").css("display", "block");
			}
			else {
				$("#ddlSeriesSortOrder").closest("div").show();
				$("#btnDeleteSeries").show().unbind("click").bind("click", function () {
					if (confirm(locale.get('Are you sure you want to delete') + ': "' + dataGroup.groupName + '"?')) {
						Storyboard.DataGroupLogic.deleteDataGroupForLayoutElementItem(dataGroup, contentElement);
						$('.editSelectedSeries').hide();
					}
				});
				$("#DUI-ST-MULTIEDIT").css("display", "none");
			}

			ChartSetupDataCom.BindDataGroup(dataGroup, layoutElement, contentElement);
		}
		
		function getSelectedVariablesIds() {
			var ids = [];
			$('#selectedVarBox option').each(function () {
				ids.push(this.value);
			})

			return ids;
		}
		

		var Handlers = {
			setDataSimpleTable: function (target) {
				var vids = null;
				var frId = $('#formatRulesIds').val();
				var rid = Helpers.getReportID();

				var editedGroup = ChartSetupUIObj.GetDatagroupFromGui();
				var dgid =  editedGroup.dataGroupId;
				var dgguid = editedGroup.guid;

				var ct2 = null;

				API.setDataSimpleTable({ vids: vids, frId: frId, rid: rid, dgid: dgid, dgguid: dgguid, ct2: ct2 })
					.done(function (data) {
						$('#setupHolder').after($('#formattingRules').css('display', 'block'));
						$('#ifrRules').attr('src', '../TableTools/FormattingSetup.aspx');
					})
					.fail(function (data) { });
			},
			setData: function (target) {
				var vids = getSelectedVariablesIds().join(',');
				var frId = $('#respFormatRulesIds').val();
				var rid = Helpers.getReportID();

				var dgid = null;
				var dgguid = null;
				var ct2 = null;

				if (vids == null || vids == "") vids = 0;
				if (frId == null || frId == "") frId = 0;

				API.setData({ vids: vids, frId: frId, rid: rid, dgid: dgid, dgguid: dgguid, ct2: ct2 })
					.done(function (data) {
						$('#setupHolder').after($('#respFormattingRules').css('display', 'block'));
						$('#ifrRespRules').attr('src', '../TableTools/FormattingSetup.aspx');
					})
					.fail(function (data) { });
			}, 
			setDataCT: function (target) {
				var vids = null;
				var frId = $("#formatRulesIds_ct").val();
				var rid = Helpers.getReportID();

				var dgid = null;
				var dgguid = null;

				var ct2 = true;

				API.setDataCT({ vids: vids, frId: frId, rid: rid, dgid: dgid, dgguid: dgguid, ct2: ct2 })
					.done(function (data) {
						$("#formattingRules_ct").css("display", "block");
						$('#ifrRules_ct').attr('src', '../TableTools/FormattingSetup.aspx');
					})
					.fail(function (data) { alert("ERROR") });
			}
		}

		Storyboard.DataGroupLogic.eventUpdateDataGroupList = function (dataGroupInfo, selectedGroup) {
			selectedGroup = selectedGroup || dataGroupInfo[0].dgGuid;

			var i = 0, dataGroup;
			$(".dgButton:not(.dgButtonTemplate)").remove();
			var template = $(".dgButtonTemplate").clone().removeClass("dgButtonTemplate");
			$("#ddlSeriesSortOrder option").remove();
			for (; i < dataGroupInfo.length; i++) {
				dataGroup = dataGroupInfo[i];
				dataGroup.sortOrder = i + 1;
				var button = template.clone().attr("dgGuid", dataGroup.dgGuid).val(dataGroup.groupName).show();
				$("#btnCreateDataGroup").before(button);

				button.bind("click", function () {
					$('#setupChart .dataGroupsSelections .linkButton').attr('disabled', 'disabled');
					var dgGuid = $(this).attr("dgGuid");
					selectDataGroupButton(dgGuid);
					storeCurrentDataGroup();

					editDatagroup(dgGuid, layoutElement, contentElement);
				});
				if (i !== 0)
					$("#ddlSeriesSortOrder").append("<option value='" + (i + 1) + "'>" + (i + 1) + "</option>");
			}

			updateSortOrder();
			selectDataGroupButton(selectedGroup);
			editDatagroup(selectedGroup, layoutElement, contentElement);
		};

		function updateSortOrder() {
			$(".dgButton:not(.dgButtonTemplate)").each(function (i) {
				var dg = Storyboard.DataGroupLogic.GetDataGroupWithGuid(contentElement, $(this).attr("dgguid"));
				dg.sortOrder = i + 1;
			});
		}

		function getScatterSeries() {
			var mapFn = function (v) { return $(v).val(); };

			var yNodes = $.map($('option', '#lbScatterY'), mapFn);
			var zNodes = $.map($('option', '#lbScatterZ'), mapFn);
			var labels = $.map($('.scatterLabel > input', '#scatterSeriesOptions'), mapFn);
			var shortTexts = $.map($('.scatterShortText > input', '#scatterSeriesOptions'), mapFn);
			var symbols = $.map($('.scatterSymbol > select', '#scatterSeriesOptions'), mapFn);
			//create mapping objects from the 'x axis' listbox

			var mappings = $.map($('option', '#lbScatterX'), function (v, index) {
				//check if both x and y is matched, else return null
				if (!$(v).val() || !yNodes[index]) return null;

				return {
					xAxisNode: $(v).val(),
					yAxisNode: yNodes[index],
					zAxisNode: zNodes[index],
					sortOrder: index + 1,
					label: labels[index],
					shortText: shortTexts[index],
					symbol: symbols[index],
					color: Helpers.convertFromHexToDecimal($('#seriesColor' + index).DUIColorPicker('get.selectedColor')),
					color_colorPlaceholderId: $('#seriesColor' + index).DUIColorPicker('get.selectedColorId') || ""
				};
			});
			return mappings;
		}

		function getScatterOptions() {
			return {
				labelPosition: parseInt($("input[name='scatterLabelPos']:checked").val() || 1),
				colorSource: $("#ddlColorSource").val(),
				MinRadius: $("#txtMinScatterRadius").val(),
				MaxRadius: $("#txtMaxScatterRadius").val(),
				pointOpacity: $('#txtScatterPointOpacity').val(),
				shortTextType: $('#ddlScatterShortTextType').val() || 4
			};
		}

		function selectDataGroupButton(dgGuid) {
			$(".dgButton").removeClass("selectedButton");
			$(".dgButton[dgGuid=" + dgGuid + "]").addClass("selectedButton");
			$("#dgGuid").val(dgGuid);
		}

		function performScatterPostSaveFixes(contentElement, seriesType) {
			var dataGroups = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);

			for (var i = 0, dg; (dg = dataGroups[i]); i++) {
				//move all grouped items to y-axis except for datetime that should be on x-axis
				//hfilter items will be removed completely since we won't support it now
				for (var j = 0, grouping; (grouping = dg.groupedItems[j]); j++) {
					if (grouping.groupType == Storyboard.Constants.GroupTypes.TIMEPERIOD)
						grouping.position = Storyboard.Constants.Axis.legend;
					else if (grouping.groupType == Storyboard.Constants.GroupTypes.FILTER && grouping.value == '0') {
						dg.groupedItems.splice(j, 1);
						j--;
					}
					else
						grouping.position = Storyboard.Constants.Axis.axis;
				}

				//set series type to scatter too
                dg.seriesSettings.seriesType = seriesType;
                dg.seriesSettings.seriesAttribute = 0; // Side by side
				dg.timeSelections.timeInterval = 7; //full period
				dg.seriesSettings.matchXAxisOnText = false;

				if (!dg.isMain) {
					dg.useSecondaryAxis = true;
					dg.axisOptions.isSecondary = true;
				}
				else {
					var scatterSeriesInGui = getScatterSeries();
					if (scatterSeriesInGui.length > 0) {
						dg.scatterSeries = scatterSeriesInGui;
						dg.scatterOptions = getScatterOptions();
						dg.scatterMeanOptions = ChartSetupUIObj.GetScatterMeanOptions();
						dg.ScatterColorTemplate = $('#seriesColorCategoryScatter').val() || '';
					}
				}

				Storyboard.DataGroupLogic.SetDataGroupWithGuid(contentElement, dg);

			}
		}

		function performSimpleTablePostSaveFixes(contentElement) {
			var dataGroups = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);

			for (var i = 0, dg; (dg = dataGroups[i]); i++) {
				dg.seriesSettings.matchXAxisOnText = false;
				dg.tableLayoutSettings = {
					useFullWidth: $("#chbUseFullWidth").attr("checked"),
					useFullHeight: $("#chbUseFullHeight").attr("checked")
				};

				Storyboard.DataGroupLogic.SetDataGroupWithGuid(contentElement, dg);
			}
		}

		function validateDataGroups() {
			var dataGroups = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);
			var seriesType = dataGroups[0].seriesSettings.seriesType;
			var seriesTypes = Storyboard.Constants.SeriesTypes;
			if (seriesType == seriesTypes.SCATTER) {
				if (dataGroups.length < 2) {
					Storyboard.LayoutControls.showMessage('Please create two series in order to build a scatter chart');
					return false;
				}
				else if (dataGroups.length >= 4) {
					Storyboard.LayoutControls.showMessage('Please create less then four series in order to build a scatter chart');
					return false;
				}
				else if (!loadedScatterOptions) {
					Storyboard.LayoutControls.showMessage("Please use the tab 'Custom chart settings' to setup the chart before previewing it");
					return false;
				}
			}
			else if (seriesType == seriesTypes.BUBBLE) {
				if (dataGroups.length < 3) {
					Storyboard.LayoutControls.showMessage('Please create three series in order to build a bubble chart');
					return false;
				}
				else if (dataGroups.length >= 4) {
					Storyboard.LayoutControls.showMessage('Please create less then four series in order to build a bubble chart');
					return false;
				}
				else if (!loadedScatterOptions) {
					Storyboard.LayoutControls.showMessage("Please use the tab 'Custom chart settings' to setup the chart before previewing it");
					return false;
				}
			}
			return true;
		}

		function checkScatterOptions() {
			var dataGroups = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);
			var seriesType = dataGroups[0].seriesSettings.seriesType;
			var seriesTypes = Storyboard.Constants.SeriesTypes;
			if (seriesType == seriesTypes.SCATTER || seriesType == seriesTypes.BUBBLE) {
				loadedScatterOptions = false;
			}
		}

		function storeCurrentDataGroup(applyFiltersToSubDgs) {
			var editedGroup = ChartSetupUIObj.GetDatagroupFromGui();
			var dgs;

            Storyboard.DataGroupLogic.SetDataGroupWithGuid(contentElement, editedGroup);

            // store styles
            if (contentElement.itemType == Storyboard.Constants.itemTypes.CHART) {
                var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(contentElement);
                Storyboard.DataGroupLogic.SetChartStyleCacheWithGuid(ChartSetupUIObj.GetChartStyles(), layoutElement.guid);
            }

			//post-save "callback" to fix data groups after they have been saved. 
			//Should really be moved out into a Mediator like class, but here goes..
			var seriesType = editedGroup.seriesSettings.seriesType;
			var seriesTypes = Storyboard.Constants.SeriesTypes;
			if (seriesType == seriesTypes.SCATTER || seriesType == seriesTypes.BUBBLE) {
				performScatterPostSaveFixes(contentElement, seriesType);
			}
			else if (contentElement.itemType == Storyboard.Constants.itemTypes.SIMPLETABLE) {
				performSimpleTablePostSaveFixes(contentElement);
			}
			else {
				//make sure that if user has changed series type of the main group from scatter to something else,
				//all the other data groups must inherit the same series type if they are scatters
				if (editedGroup.isMain) {
					dgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);
					for (var i = 0, dg; (dg = dgs[i]); i++) {
						var st = dg.seriesSettings.seriesType;
						if (!dg.isMain && (st == seriesTypes.BUBBLE || st == seriesTypes.SCATTER)) {
							dg.seriesSettings.seriesType = editedGroup.seriesSettings.seriesType;
						}
					}
				}
			}

			// update series user events
			dgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);
			for (let i = 0, dg; (dg = dgs[i]); i++) {
				dg.userEvents = Storyboard.LayoutDesigner.UserEvents.getEventsOptions(
					ChartSetupDataBinding.GetBoundContentType() == Storyboard.Constants.itemTypes.CHART ? $('#divChart') : $('#divTable'));
			}

			if (editedGroup.isMain && applyFiltersToSubDgs == true) {
				dgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);
				// update subseries' filters and groupedItems to match maingroup's
				for (let i = 0, dg; (dg = dgs[i]); i++) {
					if (!dg.isMain) {
						dg.filters = editedGroup.filters;
						for (var j = 0, item; (item = dg.groupedItems[j]); j++) {
							if (item.groupType == Storyboard.Constants.GroupTypes.FILTER) {
								dg.groupedItems.splice(j, 1);
								j--;
							}
						}
						for (j = 0, item; (item = editedGroup.groupedItems[j]); j++) {
							if (item.groupType == Storyboard.Constants.GroupTypes.FILTER) {
								dg.groupedItems.push(item);
							}
						}

						Storyboard.DataGroupLogic.SetDataGroupWithGuid(contentElement, dg);
					}
				}
			}
		}
		
		Storyboard.GuiEvents.DataGroupEdit = {
			storeCurrentDataGroup: storeCurrentDataGroup,
			selectDataGroupButton: function (dgGuid) {
				$(".dgButton").removeClass("selectedButton");
				$(".dgButton[dgGuid=" + dgGuid + "]").addClass("selectedButton");
				$("#dgGuid").val(dgGuid);
			},
			loadDataGroups: function () {
				Storyboard.DataGroupLogic.LoadDataGroupsForLayoutElementItem(contentElement, layoutElement);
			},
			getDataGroups: function () {
				return Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(contentElement);
			},
			getOrderedDataGroups: function () {
				var dataGroups = Storyboard.GuiEvents.DataGroupEdit.getDataGroups();
				if (!dataGroups[0].sortOrder || dataGroups[0].sortOrder == 0) {
					for (var i = 0; i < dataGroups.length; i++)
						dataGroups[i].sortOrder = i + 1;
				}
				return dataGroups;
			},
			getDeletedDataGroups: function () {
				return Storyboard.DataGroupLogic.getDeletedDataGroupsForLayoutElementItem(contentElement);
			},
			getEditedChartElement: function () {
				return contentElement;
			},
			setChartStyleCacheWithGuid: function (styles, guid) {
				Storyboard.DataGroupLogic.SetChartStyleCacheWithGuid(styles, guid);
			},
			getChartStyleCacheWithGuid: function () {
				return Storyboard.DataGroupLogic.GetChartStyleCacheWithGuid(layoutElement.guid);
			},
			clearDataGroups: function () {
				Storyboard.DataGroupLogic.clearDataGroupsForGuid(contentElement);
			},
			validateDataGroups: validateDataGroups,
			getScatterSeries: getScatterSeries,
			getScatterOptions: getScatterOptions
		};
	}

})(window.Storyboard = (window.Storyboard || {}));
